import {RoutesParts} from '../../../constants/routes-parts';
import {RoutesPaths} from '../../../routes/routes-paths/routes-paths';

export const CardlessWithdrawalRoutesPaths = {
  RECIPIENT_DETAILS: RoutesPaths.CARDLESS_WITHDRAWAL + '/recipient-details',
  CONFIRM: RoutesPaths.CARDLESS_WITHDRAWAL + RoutesParts.CONFIRM,
  OTP: RoutesPaths.CARDLESS_WITHDRAWAL + RoutesParts.OTP,
  SUCCESS: RoutesPaths.CARDLESS_WITHDRAWAL + RoutesParts.SUCCESS
};
